import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import masterService from 'services/MasterService';

export const initialState = {
    loading: false,
    message: '',
    list: null,
    sublist: null,
    subloading: false
}

export const shiftListAll = createAsyncThunk('/shift/list', async (data, { rejectWithValue }) => {

    try {
        const response = await masterService.getShift(data)
        return response.data;
    } catch (err) {
        return rejectWithValue(err.response?.data?.message || 'Error')
    }
});

export const shiftSlice = createSlice({
    name: 'shift',
    initialState,
    reducers: {

        shiftList: (state, action) => {
            state.loading = true
            state.list = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(shiftListAll.pending, (state) => {

                state.loading = false
            })
            .addCase(shiftListAll.fulfilled, (state, action) => {
                state.loading = true
                state.list = action.payload
            })
    },
})

export const {
    shiftList
} = shiftSlice.actions

export default shiftSlice.reducer

